import { DEFAULT_ITEMS_PARAMS } from '../../../../model/http';
import { PowerOlxV2Tab } from '../../../../components/tabs/enums/tabs.enum';
import {
  OLX_ADVERT_ACTIVE_TAB_STATUSES,
  OLX_ADVERT_INACTIVE_TAB_STATUSES,
  OLX_ADVERT_PENDING_TAB_STATUSES,
  OLX_ADVERT_REJECTED_TAB_STATUSES,
  OLX_ADVERT_UNPAID_TAB_STATUSES,
  OlxDeliveryStatusShort,
  OlxItem,
  OlxPackageStatus,
} from './power-olx-v2.interface';
import { PLANNER_FILTERS } from '../../../../interfaces/planner-table.interface';

export interface OlxDataSource {
  items: OlxItem[];
  page_size: number;
  page_index: number;
  length: number;
}

export interface PowerOlxFilterItem {
  name: string;
  values: string[];
  color: string;
  key?: string;
  inactive?: boolean;
  selected?: boolean;
  icon?: string;
}

export const POWER_OLX_FILTERS_MAP: Record<PowerOlxV2Tab, PowerOlxFilterItem[]> = {
  [PowerOlxV2Tab.ADVERTS]: [
    {
      key: 'active',
      name: 'olx.adverts.active',
      values: OLX_ADVERT_ACTIVE_TAB_STATUSES,
      color: 'green',
      icon: 'check_circle',
    },
    {
      key: 'waiting',
      name: 'olx.adverts.pending',
      values: OLX_ADVERT_PENDING_TAB_STATUSES,
      color: 'gray',
      icon: 'pending',
    },
    {
      key: 'payment',
      name: 'olx.adverts.unpaid',
      values: OLX_ADVERT_UNPAID_TAB_STATUSES,
      color: 'orangered',
      icon: 'money_off',
    },
    {
      key: 'deactivate',
      name: 'olx.adverts.inactive',
      values: OLX_ADVERT_INACTIVE_TAB_STATUSES,
      color: 'orange',
      icon: 'watch_later',
    },
    {
      key: 'canceled',
      name: 'olx.adverts.rejected',
      values: OLX_ADVERT_REJECTED_TAB_STATUSES,
      color: 'red',
      icon: 'block',
    },
  ],
  [PowerOlxV2Tab.PLANNERS]: PLANNER_FILTERS,
  [PowerOlxV2Tab.BACKUPS]: [],
  [PowerOlxV2Tab.PACKAGES]: [
    {
      key: OlxPackageStatus.ACTIVE,
      name: 'olx.packages.active',
      values: [OlxPackageStatus.ACTIVE],
      color: 'green',
      icon: 'check_circle',
    },
    {
      key: OlxPackageStatus.INACTIVE,
      name: 'olx.packages.inactive',
      values: [OlxPackageStatus.INACTIVE],
      color: 'red',
      icon: 'cancel',
    },
  ],
  [PowerOlxV2Tab.TEMPLATES]: [],
  [PowerOlxV2Tab.DELIVERIES]: [
    {
      key: OlxDeliveryStatusShort.ACCEPTED,
      name: 'olx.delivery.status_short.accepted',
      values: [OlxDeliveryStatusShort.ACCEPTED],
      color: 'green',
      icon: 'check_circle',
    },
    {
      key: OlxDeliveryStatusShort.WAITING,
      name: 'olx.delivery.status_short.waiting',
      values: [OlxDeliveryStatusShort.WAITING],
      color: 'gray',
      icon: 'pending',
    },
    {
      key: OlxDeliveryStatusShort.REJECTED,
      name: 'olx.delivery.status_short.rejected',
      values: [OlxDeliveryStatusShort.REJECTED],
      color: 'red',
      icon: 'block',
    },
  ],
};

export const DEFAULT_OLX_ITEMS_PARAMS = { ...DEFAULT_ITEMS_PARAMS, filters: [] };

export enum DisplayMode {
  CARDS = 'CARDS',
  TABLE = 'TABLE',
}

export const CREATE_ADVERT_BUTTON_TABS = [
  PowerOlxV2Tab.ADVERTS,
  PowerOlxV2Tab.PLANNERS,
];


export const BULK_ACTIONS_TABS = [
  PowerOlxV2Tab.ADVERTS,
  PowerOlxV2Tab.PLANNERS,
  PowerOlxV2Tab.BACKUPS,
];

